import TableChartSidebar from 'components/Table/TableChartSidebar';
import { PitcherReportChartConfigDto, PitchTypeStatsDto, TableChartConfigDto } from 'types/CodegenReportTypes';
import { ChartConfigProps } from 'utilities/chartIdToComponent';

const disabledVisibleStats: (keyof PitchTypeStatsDto)[] = ['pitchType'];

const PitchTypeStatsChartSidebar = (props: ChartConfigProps<TableChartConfigDto, PitcherReportChartConfigDto>) => {
  return (
    <TableChartSidebar
      chartId='PitchTypeStatsChart'
      configKey='pitchTypeStatsChartConfig'
      disabledVisibleStats={disabledVisibleStats}
      {...props}
    />
  );
};

export default PitchTypeStatsChartSidebar;
